import { render, staticRenderFns } from "./instructions.vue?vue&type=template&id=4295afdc"
import script from "./instructions.vue?vue&type=script&lang=js"
export * from "./instructions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports